import api from 'api'
import { queryParamSerializer } from 'lib/api/queryParamSerializer'
import { z } from 'zod'

const vndlyPositionIssuesItemSchema = z.object({
  instanceId: z.number(),
  companyId: z.number(),
  positionId: z.number(),
  positionName: z.string(),
  issues: z.array(z.string()),
})

export type VndlyPositionIssuesItem = z.infer<
  typeof vndlyPositionIssuesItemSchema
>

const vndlyPositionIssuesItemsSchema = z.array(vndlyPositionIssuesItemSchema)

export type VndlyPositionIssuesItems = z.infer<
  typeof vndlyPositionIssuesItemsSchema
>

type ListVndlyPositionIssuesRequest = {
  page: number
  pageSize: number
  daysAgo?: number | null
  instanceIds?: number[] | null
  companyIds?: number[] | null
}

const listVndlyPositionIssuesResponseSchema = z.object({
  items: vndlyPositionIssuesItemsSchema,
  totalRows: z.number(),
  totalPages: z.number(),
  currentPage: z.number(),
  pageSize: z.number(),
})

export type ListVndlyPositionIssuesResponse = z.infer<
  typeof listVndlyPositionIssuesResponseSchema
>

export const listVndlyPositionIssues = async (
  request: ListVndlyPositionIssuesRequest
): Promise<ListVndlyPositionIssuesResponse> => {
  const params = {
    page: request.page,
    page_size: request.pageSize,
    days_ago: request.daysAgo,
    instance_ids: request.instanceIds,
    company_ids: request.companyIds,
  }

  const response = await api.get<ListVndlyPositionIssuesResponse>(
    '/admin/vndly/positions_issues',
    { params, paramsSerializer: queryParamSerializer }
  )
  return listVndlyPositionIssuesResponseSchema.parse(response.data)
}
